import React, { useState } from 'react'
import { removeTags } from '../../../utils/removeTags'
import sanitizeHtml from 'sanitize-html'
import ArticleCard from '../AuthorBio/ArticleCard'
import Button from '@/components/atoms/Button/ButtonV2'
import IconChevronDownXs from '@/components/icons/IconChevronDownXs/IconChevronDownXs'

interface Article {
  slug: string
  url: string
  title: string
  content: string
  readingTime: string
  excerpt: string
  categories: {
    nodes: {
      slug: string
    }[]
  }
  coverImage: string
}

interface ArticlesGridProps {
  articles: Article[]
  heading?: string
  initialListCount?: number
}

const PAGE_SIZE = 8

const ArticlesGrid: React.FC<ArticlesGridProps> = ({
  articles,
  heading,
  initialListCount = PAGE_SIZE
}) => {
  const [currentPage, setCurrentPage] = useState(
    Math.ceil(initialListCount / PAGE_SIZE)
  )

  const displayedArticles = articles.slice(0, currentPage * PAGE_SIZE)

  return (
    <>
      <div className="flex flex-col items-start pt-8">
        {heading && (
          <div className="text-left font-FieldsVariable text-2xl font-medium leading-8 tracking-normal text-gray-1100">
            {heading}
          </div>
        )}

        <div className="mt-6 flex flex-wrap gap-4 sm:mt-0">
          {displayedArticles?.map((article) => (
            <ArticleCard
              slug={article?.slug}
              url={article?.url}
              title={article?.title}
              content={
                article?.excerpt || removeTags(sanitizeHtml(article?.content))
              }
              excerpt={article?.excerpt}
              categories={article?.categories}
              readingTime={article?.readingTime}
              coverImage={article?.coverImage}
              key={article?.slug}
            />
          ))}
        </div>
      </div>

      {articles.length > displayedArticles.length ? (
        <div className="flex items-center justify-center pb-2 pt-8">
          <div className="hidden h-1 grow border-t border-gray-300 md:block lg:min-w-[300px]"></div>
          <Button
            type="tertiary"
            aria-label="Show More Articles"
            onClick={() => setCurrentPage(currentPage + 1)}
            className="w-full md:w-auto"
          >
            More Articles
            <IconChevronDownXs
              strokeWidth="0.2"
              className="text-gray-900"
            />
          </Button>
          <div className="hidden h-1 grow border-t border-gray-300 md:block lg:min-w-[300px]"></div>
        </div>
      ) : (
        <div className="flex items-center justify-center pb-2 pt-8">
          <div className="hidden h-1 grow border-t border-gray-300 md:block lg:min-w-[300px]"></div>
        </div>
      )}
    </>
  )
}

export default ArticlesGrid
